import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StatusTag from 'components/atoms/ListingsTable/StatusTag'
import Link from 'components/shared/Link'

class TableCell extends Component {
  render () {
    if (this.props.type === 'status') {
      return (
        <td>
          <StatusTag content={this.props.content} />
        </td>
      )
    } else if (this.props.photo) {
      return (
        <td>
          <div className='flex items-center justify-between'>
            <div> {this.props.content} </div>
            <img alt={this.props.alt} src={this.props.photo} style={{ width: '120px', height: '80px', objectFit: 'cover' }} />
          </div>
        </td>

      )
    } else if (this.props.type === 'cancel') {
      return <td style={this.props.style}>  <Link onClick={this.props.onCancelLinkClick} linkName={this.props.content} /> </td>
    } else {
      return (
        <td> {this.props.content} </td>
      )
    }
  }
}

TableCell.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  type: PropTypes.string,
  handleCancelLink: PropTypes.func
}

export default TableCell
